export var pageTitles = {
    pojobnames: 'Po/Job Name',
    proallowance: 'Pro Allowance Management',
    assignproallowance: 'Assign Pro Allowance',
};
